import {
  Route,
  createRoutesFromElements,
  RouterProvider,
  createBrowserRouter,
  Link
} from "react-router-dom";
import ErrorBoundary from "./error_handling/ErrorBoundary";
import LoginScreen, { LoginAction } from "./pages/LoginScreen";
import "./styles/general.css";
import { Buddies } from "./pages/Buddies";
import { BuddyDetails } from "./pages/BuddyDetails";
import { Dashboard } from "./pages/Dashboard";
import { DashboardLayout } from "./layouts/dashboard_layout";
import { Members } from "./pages/Members";
import { MemberDetails } from "./pages/MemberDetails";
import { MemberDetailsSubscriptions } from "./pages/MemberDetailsSubscriptions";
import { MemberDetailsServices } from "./pages/MemberDetailsServices";
import { MemberDetailsVehicles } from "./pages/MemberDetailsVehicles";
import { VehicleDetails } from "./pages/VehicleDetails";
import { Vehicles } from "./pages/Vehicles";
import { BuddyDetailsDetail } from "./pages/BuddyDetails_detail";
import { BuddyDetailsMembers } from "./pages/BuddyDetailsMembers";
import { AddMember, AddCustomerAction } from "./pages/AddMember";
import { Services } from "./pages/Services";
import { ServiceDetails } from "./pages/ServiceDetails";
import { Customers, HydrateFallback } from "./pages/Customers";
import {
  getCustomerDetailsLoader,
  getCustomersLoader,
  getMembersLoader,
  getVehiclesLoader,
  getServiceDetailsLoader,
  getSubscriptionPlansLoader,
  getVehicleDetailsLoader,
  getBuddiesLoader,
  getBuddyDetailsLoader,
  dashboardLoader,
  getTicketInvoiceLoader,
  RoadworthyAndLicensePageLoader,
  AddOrderTicketLoader,
  getServiceTicketsLoader,
  getOrderDetailsLoader,
  SubscriptionHistoryPageLoader,
  wahuLoader
} from "./services/loaders";
import { AddBuddy, AddBuddyAction } from "./pages/AddBuddy";
import { Subscriptions } from "./pages/Subscriptions";
import { AddSubscription } from "./pages/AddSubscription";
import { AddSubscriptionAction } from "./pages/AddSubscription";
import { VehicleDetailsServices } from "./pages/VehicleDetailsServices";
import ProtectedRoute from "./layouts/protected_route";
// import { AddVehicleService } from "./pages/AddVehicleService";
import ResetPassword, { ResetPasswordAction } from "./pages/ResetPassword";
import { MemberDetailsNotes } from "./pages/MemberDetails_notes";
import { VehicleDetailsNotes } from "./pages/VehicleDetails_notes";
import { AddCustomerVehicle, AddCustomerVehicleAction } from "./pages/AddCustomerVehicle";
import { ServiceInvoice } from "./pages/ServiceInvoice";
import RoadworthyAndLicensePage from "./pages/Roadworthy";
// import { AddOrderTicket } from "./pages/AddOrderTicket";
import { OrderDetails } from "./pages/OrderDetails";
import SubscriptionHistoryPage from "./pages/SubscriptionHistory";
import { AddTicket } from "./pages/AddTicket";
import { AdminEmails } from "./pages/AdminEmails";
import { Wahu } from "./pages/Wahu";

const NotFound = () => {
  return (
    <div>
      <h1>Page not found</h1>
      <Link to={"/"}>Go back to homepage</Link>
    </div>
  );
};

function App() {
  const root = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" >
        <Route
          exact
          path="/"
          element={<LoginScreen />}
          action={LoginAction}
        />
        <Route
          path="/reset_password"
          element={<ResetPassword />}
          action={ResetPasswordAction}
        />
        <Route
          path="/wahu"
              loader={wahuLoader}
          element={<Wahu />}
        />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route
              path=""
              element={<Dashboard />}
              loader={dashboardLoader}
            />

            <Route
              path="roadworthy"
              element={<RoadworthyAndLicensePage />}
              loader={RoadworthyAndLicensePageLoader}
              />
            <Route
              path="subscription_history"
              element={<SubscriptionHistoryPage />}
              loader={SubscriptionHistoryPageLoader}
              />
            <Route path="subscriptions">
              <Route
                path=""
                element={<Subscriptions />}
                loader={getSubscriptionPlansLoader}
              />
              <Route
                path="add_subscription"
                element={<AddSubscription />}
                action={AddSubscriptionAction}
              />
            </Route>
            <Route path="buddies">
              <Route
                path=""
                element={<Buddies />}
                loader={getBuddiesLoader}
                hydrateFallback={HydrateFallback}
              />
              <Route
                path="add_buddy"
                element={<AddBuddy />}
                action={AddBuddyAction}
              />
              <Route
                path="u/:id"
                element={<BuddyDetails />}
                loader={getBuddyDetailsLoader}
                hydrateFallback={HydrateFallback}
              >
                <Route path="" element={<BuddyDetailsDetail />} />
                <Route path="members" element={<BuddyDetailsMembers />} />
              </Route>
            </Route>
            <Route path="vehicles">
              <Route
                path=""
                loader={getVehiclesLoader}
                hydrateFallback={HydrateFallback}
                element={<Vehicles />}
              />
              <Route
                path=":id"
                element={<VehicleDetails />}
                loader={getVehicleDetailsLoader}
              >
                {/* <Route path="" element={<VehicleDetailsDetail />} /> */}
                {/* <Route path="owner" element={<MemberDetailsDetail />} /> */}
                <Route path="services" element={<VehicleDetailsServices />} />
                <Route path="notes" element={<VehicleDetailsNotes />} />
              </Route>
              {/* <Route
                path=":id/add_service"
                element={<AddVehicleService />}
                hydrateFallback={HydrateFallback}
                // action
                loader={getVehicleDetailsLoader}
              /> */}
            </Route>
            <Route path="members">
              <Route path="" element={<Members />} loader={getMembersLoader} />
              <Route
                path="add_member"
                element={<AddMember />}
                action={AddCustomerAction}
              />
                <Route path="u/:id/:order_id" element={<OrderDetails />} loader={getOrderDetailsLoader} />
              <Route
                path="u/:id"
                element={<MemberDetails />}
                loader={getCustomerDetailsLoader}
                hydrateFallback={HydrateFallback}
              >
                {/* <Route path="" element={<MemberDetailsVehicles />} /> */}
                <Route path="vehicles" element={<MemberDetailsVehicles />} />
                <Route path="subscriptions" element={<MemberDetailsSubscriptions />} />
                <Route path="services" element={<MemberDetailsServices />} />
                <Route path="notes" element={<MemberDetailsNotes />} />

                <Route path="add_customer_vehicle" element={<AddCustomerVehicle />} action = {AddCustomerVehicleAction} />
              </Route>
              {/* <Route
                path="u/:id/add_order"
                element={<AddOrderTicket /> }
                loader={AddOrderTicketLoader}
                hydrateFallbackElement={<h1>Loading</h1>}
              /> */}
            </Route>
            <Route path="services">
              <Route path="" element={<Services />} loader={getServiceTicketsLoader} />
              <Route
                path=":vehicle_id/:service_id"
                element={<ServiceDetails />}
                loader={getServiceDetailsLoader}
                hydrateFallback={HydrateFallback}
              />
              <Route
                path="invoice/:service_id"
                loader={getTicketInvoiceLoader}
                hydrateFallback={HydrateFallback}
                element={<ServiceInvoice />}
              />

              <Route
                path="add_ticket"
                element={<AddTicket />}
                hydrateFallback={HydrateFallback}
                // loader={getVehicleDetailsLoader}
              />
            </Route>
            <Route
              path="admin-emails"
              element={<AdminEmails />}
            />
            <Route
              path="customers"
              loader={getCustomersLoader}
              element={<Customers />}
            />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    )
  );

  return (
      <RouterProvider router={root} />
  );
}

export default App;
